var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnOrdinateur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.002 61.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 850",
    d: "M85.252 52.703H0v4.649q0 1.939 2.276 3.294a10.511 10.511 0 0 0 5.474 1.357h77.5a10.506 10.506 0 0 0 5.473-1.356Q93 59.287 93 57.349v-4.646Zm-34.876 4.649h-7.75a.776.776 0 0 1 0-1.551h7.75a.776.776 0 0 1 0 1.551Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2459",
    d: "M21 4a4 4 0 0 0-4 4v34a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V8a4 4 0 0 0-4-4H21m0-4h52a8 8 0 0 1 8 8v34a8 8 0 0 1-8 8H21a8 8 0 0 1-8-8V8a8 8 0 0 1 8-8Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnOrdinateur);
export default __webpack_public_path__ + "static/media/un-ordinateur.e01cbb2c8a6c3532576d752b910cd6eb.svg";
export { ForwardRef as ReactComponent };